import React from "react";
import { SagaIterator } from "redux-saga";
import { matchPath } from "react-router-dom";
import { all, select, takeEvery } from "redux-saga/effects";
import { notification } from "components";
import { routes } from "configs";
import * as actions from "./actions";
import Notification from "../components/notification";

function* addReport({
  payload: report,
}: ReturnType<typeof actions.addReport>): SagaIterator {
  const intervalId: number = yield select(
    (state) => state.otherScores.intervalId,
  );
  const arrayIds: string[] = yield select(
    (state) => state.otherScores.arrayIds,
  );

  if (!arrayIds.length) {
    window.clearInterval(intervalId);
    localStorage.removeItem("urlOtherScores");
  } else {
    const url = arrayIds.reduce(
      (acc, id) => `${acc}student_ids_array[]=${id}&`,
      "?",
    );
    localStorage.setItem("urlOtherScores", url);
  }

  if (!matchPath(window.location.pathname, routes.teacherSection)) {
    notification.createSuccess({
      content: <Notification report={report} />,
      duration: null,
    });
  }
}

export default function* rootSaga(): SagaIterator {
  yield all([takeEvery(actions.addReport, addReport)]);
}
